var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"loading":_vm.loading}},[(!_vm.loading)?[_c('d-header',{attrs:{"actions":_vm.actions,"fluid":""}},[_c('h1',{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm.user.name)+"\n      ")])]),_vm._v(" "),_c('v-form',{attrs:{"action":"edit","user":_vm.user},on:{"success":function($event){return _vm.fetch()}}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }